import TollRoadsService from '@/api/TollRoadsService.js'
import Vue from 'vue'
export const tollRoadsModule = {
  namespaced: true,
  state: () => ({
    tollRoadsData: [],
    tollRoadsLoadStatus: 'request',
    paginationTollRoadsStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationTollRoadsStateParams.total /
        state.paginationTollRoadsStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.tollRoadsData = [...data]
    },
    create(state, data) {
      state.tollRoadsData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.tollRoadsData.findIndex(
        (x) => x.vehicle_toll_roads__id == data.id
      )
      Object.assign(state.tollRoadsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.tollRoadsData.findIndex(
        (x) => x.vehicle_toll_roads_id == id
      )
      state.tollRoadsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationTollRoadsStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.tollRoadsLoadStatus = 'request'
    },
    load_success(state) {
      state.tollRoadsLoadStatus = 'success'
    },
    load_error(state) {
      state.tollRoadsLoadStatus = 'error'
    }
  },
  actions: {
    getTollRoadsAll({ commit }, params) {
      commit('load_request')

      TollRoadsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createTollRoadsData({ commit }, createData) {
      TollRoadsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editTollRoadsMultiple({ commit }, { id, dataEdit }) {
      TollRoadsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteTollRoadsData({ commit }, id) {
      // commit("load_request");
      TollRoadsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
